export class AmazonDeploymentStatuses {
  static Statuses = [
    { Id: 0, Name: 'Not Applicable' },
    { Id: 1, Name: 'New' },
    { Id: 7, Name: 'Deployed' },
    { Id: 12, Name: 'Retired' }
  ];

  static NameMap = {
    0: 'Not Applicable',
    1: 'New',
    7: 'Deployed',
    12: 'Retired'
  }
}